


















import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { biHottag, language, url } from '@tencent/ppd-base-libs';
import { RouteName } from '../router';
import { i18n } from '@/i18n';

@Component
export default class Header extends Vue {
  @Prop({ default: null }) public router;
  lang = language.getLanguage();
  navTypes = [
    {
      name: i18n('香港疫情'),
      value: RouteName.home,
    },
    // {
    //   name: i18n('全球疫情'),
    //   value: RouteName.overseas,
    // },
  ];

  // 计算导航列表
  get navTypeList() {
    const list: Array<Object> = [];
    const type = this.getNavType();
    this.navTypes.forEach((item) => {
      list.push(Object.assign({ checked: item.value === type }, item));
    });
    return list;
  }
  // 获取当前导航类型
  getNavType() {
    return (this.$router && this.$router.currentRoute && this.$router.currentRoute.name) || RouteName.home;
  }
  // 切换地区
  itemClick(item) {
    if (this.router) {
      this.router.push({
        name: item.value,
      });
    }
  }
}
